import React from 'react';
import { Button } from 'antd';
import { LogoutIcon } from '../../../common/icons';

interface SidebarFooterProps {
  isCollapsed: boolean;
  isMobile: boolean;
  onLogoutClick: () => void;
}

export const SidebarFooter: React.FC<SidebarFooterProps> = ({ isCollapsed, isMobile, onLogoutClick }) => {
  return (
    <div className="sidebar-footer">
      <Button type="text" icon={<LogoutIcon />} onClick={onLogoutClick} className="logout-button" block>
        {(!isCollapsed || isMobile) && 'Logout'}
      </Button>
    </div>
  );
};
